<div class="recipe-block" [class.recipe-block--with-bg]="hasBackground()">
  @if (block().name) {
    <div class="recipe-name">
      @for (seg of parseTitleSegments(block().name!); track $index) {
        @if (seg.type === 'text') {
          <markdown [data]="seg.text!" [inline]="true" katex [katexOptions]="katexOptions" />
        } @else {
          <span
            class="inline-icon"
            [class.inline-icon--with-bg]="seg.showBackground"
            [style.color]="seg.color"
            [style.background-color]="seg.showBackground ? getIconBgColor(seg.color) : null"
          >
            @if (seg.iconType === 'fa') {
              <i [class]="'fas fa-' + seg.name"></i>
            } @else {
              <img [src]="seg.name" alt="" class="inline-icon-img" />
            }
          </span>
        }
      }
    </div>
  }

  <div class="recipe-steps">
    @for (step of block().steps; track $index) {
      <div class="recipe-step">
        <span class="step-badge">{{ $index + 1 }}</span>
        <div class="step-title">
          @for (seg of parseTitleSegments(step.title); track $index) {
            @if (seg.type === 'text') {
              <markdown [data]="seg.text!" [inline]="true" katex [katexOptions]="katexOptions" />
            } @else {
              <span
                class="inline-icon"
                [class.inline-icon--with-bg]="seg.showBackground"
                [style.color]="seg.color"
                [style.background-color]="seg.showBackground ? getIconBgColor(seg.color) : null"
              >
                @if (seg.iconType === 'fa') {
                  <i [class]="'fas fa-' + seg.name"></i>
                } @else {
                  <img [src]="seg.name" alt="" class="inline-icon-img" />
                }
              </span>
            }
          }
        </div>
        <div class="step-content">
          <ng-container *ngComponentOutlet="contentRenderer(); inputs: { blocks: step.content }" />
        </div>
      </div>
    }
  </div>
</div>
